export interface ImportedScan {
  EID: string;
  scanTime: string;
}

export enum Xrs2iEventType {
  SCAN = "scan",
  INVALID_EID = "invalidEid",
  ERROR = "error",
  SAVED_SCANS_PROGRESS = "savedScansProgress",
  SAVED_SCANS_COMPLETE = "savedScansComplete",
}

export interface Xrs2iScanEvent {
  type: Xrs2iEventType.SCAN;
  eid: string;
  created: string;
}

export interface Xrs2iInvalidEidEvent {
  type: Xrs2iEventType.INVALID_EID;
}

export interface Xrs2iErrorEvent {
  type: Xrs2iEventType.ERROR;
  code: string;
}

export interface Xrs2iSavedScansProgressEvent {
  type: Xrs2iEventType.SAVED_SCANS_PROGRESS;
  completedSessions: number;
  totalSessions: number | null;
  importedScans: Record<string, ReadonlyArray<ImportedScan>>;
}

export interface Xrs2iSavedScansCompleteEvent {
  type: Xrs2iEventType.SAVED_SCANS_COMPLETE;
  success: boolean;
  completedSessions: number;
  totalSessions: number | null;
  importedScans: Record<string, ReadonlyArray<ImportedScan>>;
}

export type Xrs2iEvent =
  | Xrs2iScanEvent
  | Xrs2iInvalidEidEvent
  | Xrs2iErrorEvent
  | Xrs2iSavedScansProgressEvent
  | Xrs2iSavedScansCompleteEvent;

export type Xrs2iDeviceEventHandler = (event: Xrs2iEvent) => void;

export interface Xrs2iDeviceHandle {
  resetHardwareConfig(): Promise<void>;
  readSavedScans(): Promise<void>;
  cancelReadSavedScans(): void;
  destroy(): void;
}

export enum DeviceMode {
  IDLE,
  AWAITING_EID_OUTPUT_FORMAT,
  DOWNLOADING_SAVED_SCANS,
}

export enum DownloadStep {
  WAITING_FOR_INITIAL_RECORD_RESET = "waiting_for_initial_record_reset",
  WAITING_FOR_SESSION_DATA_MODE = "waiting_for_session_data_mode",
  WAITING_FOR_SESSION_COUNT = "waiting_for_session_count",
  WAITING_FOR_SESSION_ID = "waiting_for_session_id",
  WAITING_FOR_SESSION_SELECTION = "waiting_for_session_selection",
  WAITING_FOR_SESSION_NAME = "waiting_for_session_name",
  WAITING_FOR_SESSION_RECORD_RESET = "waiting_for_session_record_reset",
  WAITING_FOR_FIELD_CODE = "waiting_for_field_code",
  WAITING_FOR_RECORD = "waiting_for_record",
}

export interface SavedSession {
  sessionId: string;
  sessionName?: string;
  scans: ImportedScan[];
}

export interface DownloadState {
  step: DownloadStep;
  totalSessionCount: number | null;
  sessionIds: string[];
  currentSessionIndex: number;
  completedSessionCount: number;
  sessionsById: Record<string, SavedSession>;
}
